<form [formGroup]="form" (ngSubmit)="edit()">
  <div class="big-name-change w-100 h-100">
    <h1 mat-dialog-title class="etn-title">Edit commission</h1>
    <div class="d-flex text-left justify-content-center flex-column">
      <input type="text" formControlName="commission" class="input-text-change" [value]="data.commission">
      @if (form.get('commission')?.touched && form.get('commission')?.invalid) {
        <div class="error-message">
          @if (form.get('commission')?.errors?.['commission']) {
            <div>Commission is required</div>
          }
          @if (form.get('commission')?.errors?.['commission']) {
            <div>Invalid commission</div>
          }
        </div>
      }
      @if (errorMessage) {
        <div class="error-message">{{ errorMessage }}</div>
      }
    </div>
    <div class="option-select">
      <button mat-button class="cancel-btn" type="button" (click)="onNoClick()">Cancel</button>
      <button mat-button
              [ngClass]="{
                'save-btn': !isButtonDisabled(),
                'save-btn-disabled': isButtonDisabled()
              }"
              type="submit"
              [disabled]="isButtonDisabled()">Save</button>
    </div>
  </div>
</form>
